export default {"src":"/_next/static/media/radio-dark.06033724.svg","height":256,"width":256};